import styled, { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
    @font-face {
        font-family: 'Lato';
        src: url('/fonts/Lato-Regular.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
    }

    @font-face {
        font-family: 'Lato';
        src: url('/fonts/Lato-Bold.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
    }

    body {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Lato', sans-serif;
        background-color: #f8f9fa;
        color: #333;
    }

    h1, h2, h3, h4, h5, h6, p, a, li, span {
        font-family: 'Lato', sans-serif;
        padding: 0;
        margin: 0;
    }
`

export const AppContainer = styled.div`
  background-color: #f8f9fa;
  height: 100vh;
  display: flex;
  flex-direction: column;
`

export default GlobalStyles
